import __request__ from "routing/request";
export function create(inputId, JSONbody, requestOptions) {
  return __request__("POST", `/system/inputs/${inputId}/staticfields`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(key, inputId, requestOptions) {
  return __request__("DELETE", `/system/inputs/${inputId}/staticfields/${key}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
